export default "__VITE_ASSET__11d2598b__"